<script>
import axios from "axios";
import {Pagination, Spin, Checkbox, Switch} from 'ant-design-vue';
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";
import HoldOnIcon from "@/components/Icons/HoldOnIcon.vue";
import ProjectInfoService from "@/services/projectInfoService";

export default {
	name: 'ExpertProjects',
	data() {
		return {
			categories: [],
			tab: 1,
			template: 'base_expert',
			categoryId: '',
			filteredPis: [],
			filterFavorit: false,
			filterNotScored: false,
			filterHolded: false,
			search: '',
			by: 10,
			current: 1,
			isLoading: false,
			stat: {
				notScoredProjects: '',
				scoredProjects: '',
				projectsInfos: []
			},
			competition: {
				id: '',
				name: ''
			},
			tour: ''
		}
	},
	components: {
		Pagination,
		Spin,
		Checkbox,
		Switch,
		ImageRender,
		HoldOnIcon
	},
	async created() {
		if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
			alert("Эта страница может работать некорректно в браузере Safari. Рекомендуемые браузеры Яндекс.Браузер или Google Chrome.");
		}
		if (window.categoryId.length > 0) {
			this.categoryId = parseInt(window.categoryId);
			this.template = 'base_list';
		}
		this.tour = window.tour;
		await this.getData(true);
	},
	methods: {
		async getData(init = false) {
			this.isLoading = true;
			const categories_response = await axios.post('/category/list_by_competition', null, {
				params: {
					competitionId: window.competitionId,
					currentUserId: window.currentUserId
				}
			})
			this.categories = categories_response.data;
			
			await axios.get('/api/competitions/' + window.competitionId).then((data) => {
				this.competition = data.data
			});
			
			if (this.categoryId && this.isExpert) {
				await this.getCompetitionStat();
			}
			
			if (this.isOrganizator) {
				await this.getCompetitionStat();
			}
			if (init) {
				this.handleHash();
			}
			
			this.isLoading = false;
		},
		handleHash() {
			const hash = window.location.hash.substr(1);
			if (hash.length > 0) {
				const hash_nums = hash.replace('page', '');
				const cat_id = hash_nums.split('_')[0];
				const page_num = hash_nums.split('_')[1];
				
				this.categoryId = parseInt(cat_id);
				this.template = 'base_list';
				
				if (Math.round(this.items.length / this.by) < parseInt(page_num)) {
					this.removeHash();
					this.current = 1;
				} else {
					this.current = parseInt(page_num);
				}
			} else {
				this.current = 1;
			}
		},
		async getCompetitionStat() {
			//console.log(this.categoryId, this.tour);
			const response = await axios.post('/competition/get_expert_competition_stat', null, {
				params: {
					competitionId: window.competitionId,
					categoryId: this.categoryId,
					tour: this.tour
				}
			})
			this.stat = response.data;
			this.items = this.stat.projectsInfos;
		},
		choise_competition(categoryId) {
			this.getData();
			this.categoryId = categoryId;
			this.template = 'base_list';
		},
		isEven(n) {
			return n % 2 == 0;
		},
		async favoriteClick(id) {
			
			const index = this.stat.projectsInfos.findIndex(object => {
				return object.id === id
			});
			this.stat.projectsInfos[index].isProjectInfoFavorite = !this.stat.projectsInfos[index].isProjectInfoFavorite;
			
			await axios.post('/project/makeProjectinfoFavorite', null, {
				params: {
					projectinfoId: id
				}
			});
		},
		removeHash() {
			var currentUrl = window.location.href;
			// Проверяем, есть ли якорь в URL
			if (currentUrl.indexOf('#') !== -1) {
				// Удаляем якорь из URL
				var cleanUrl = currentUrl.split('#')[0];
				// Заменяем текущий URL на URL без якоря
				window.history.replaceState({}, document.title, cleanUrl);
				window.location.hash = '';
			}
		},
		getRegionPercentage(projectInfo) {
			// Проверяем наличие данных о команде
			if (!projectInfo || !projectInfo.stage || projectInfo.stage.length === 0) return 0;
			
			const totalCities = projectInfo.stage.length;
			const capital = projectInfo.stage.filter(item =>
				item.gorod === 'Москва' ||
				item.gorod === 'Санкт-Петербург' ||
				item.region === 'Московская область' ||
				item.region === 'Ленинградская область'
			).length;
			
			// Возвращаем процент регионов (не столиц)
			return (100 - (capital * 100 / totalCities)).toFixed(2);
		},
		async searchPis() {
			
			await this.removeHash();
			this.handleHash();
			
			this.filteredPis = this.stat.projectsInfos;
			
			if (this.search.length > 0) {
				this.filteredPis = this.filteredPis.filter(object => {
					return (object?.project_name)?.toLowerCase()?.includes(this.search.toLowerCase());
				})
			}
			
			if (this.filterFavorit) {
				this.filteredPis = this.filteredPis.filter(object => {
					return object.isProjectInfoFavorite === true
				})
			}
			
			if (this.filterNotScored) {
				this.filteredPis = this.filteredPis.filter(object => {
					return object.projectScore === 0
				})
			}
			
			if (this.filterHolded) {
				this.filteredPis = this.filteredPis.filter(object => {
					return object?.isProjectInfoHolded === true
				})
			}
			// if (this.search.length > 0 || this.filterFavorit || this.filterNotScored || this.filterHolded) {
			//   this.items = this.filteredPis;
			// } else {
			//   this.items = this.stat.projectsInfos;
			// }
			
			
		},
		onPageChange(pageNum) {
			window.location = "#page" + this.categoryId + "_" + pageNum;
		},
		is_scored(projectInfo) {
			return projectInfo.projectScore > 0 || projectInfo.projectScore === '+';
		},
		getProjectAvatar(avatar) {
			return ImageService.getProjectImagePath(avatar);
		},
		async addToFavorite(projectInfo) {
			await ProjectInfoService.addToFavorite(projectInfo.isProjectInfoHolded, projectInfo.id);
			//Изменяем значение флага
			this.currentItems.map((el) => {
				if (el.id === projectInfo.id) {
					el.isProjectInfoHolded = !el.isProjectInfoHolded
				}
			})
		},
		isLowRegionPercentage(projectInfo) {
			const regionPercentage = this.getRegionPercentage(projectInfo);
			return regionPercentage < 60;
		}
	},
	computed: {
		items() {
			if (this.search.length > 0 || this.filterFavorit || this.filterNotScored || this.filterHolded) {
				return this.filteredPis;
			} else {
				return this.stat.projectsInfos;
			}
		},
		
		currentItems() {
			return this.items.slice((this.by * this.current - this.by), this.by * this.current)
		},
		current_category() {
			if (this.categories.length === 0 || this.categoryId.length === 0) {
				return {name: ''}
			}
			return this.categories.find((el) => {
				return el.id === this.categoryId
			})
		},
		currentUserRoles() {
			if (!window.currentUserRoles) {
				return [];
			}
			return Array.isArray(window.currentUserRoles) ? window.currentUserRoles : [window.currentUserRoles];
		},
		getTourName() {
			let $tourName = '';
			let $tourNumber;
			if (window.tour.length === 0) {
				$tourNumber = this.competition.tour;
			} else {
				$tourNumber = window.tour;
			}
			
			if ($tourNumber == '1') {
				$tourName = 'Лонг-лист';
			} else if ($tourNumber == '0') {
				$tourName = 'Отборочный тур';
			} else if ($tourNumber == '2') {
				$tourName = 'Шорт-лист';
			} else if ($tourNumber == '3') {
				$tourName = 'Победители';
			}
			return $tourName;
		},
		isExpert() {
			return this.currentUserRoles?.includes('ROLE_EXPERT')
		},
		isOrganizator() {
			return this.currentUserRoles?.includes('ROLE_ORGANIZATOR')
		},
		disable_vote() {
			return window.disable_vote;
		},
		
	},
	watch: {
		filterHolded() {
			this.searchPis();
		},
		filterNotScored() {
			this.searchPis();
		},
		filterFavorit() {
			this.searchPis();
		}
	}
}
</script>

<template>
	<div>
		<div class="gray_line">
			<div class="gray_inner">
				<div class="item" :class="tab === 1 ? 'active' : ''" @click="tab = 1">Требуется оценка <span
					class="has_not_scored" v-if="!isLoading">{{ stat.notScoredProjects }}</span></div>
				<!--                <a v-if="projectInfo" class="item" :class="tab === 2 ? 'active' : ''" :href="'/my_scores/'+projectInfo.competition.id">Мои оценки</a>-->
			</div>
		</div>
		<div class="request_content">
			<Spin v-if="isLoading"></Spin>
			<template v-else>
				<template v-if="template === 'base_expert' && isExpert">
					<h1>Выберите категорию конкурса</h1>
					<p v-for="category in categories" :key="category.id"><a
						@click.prevent="choise_competition(category.id)">{{ category.name }}</a> (Всего:
						{{ category.count }}, неоцененных: {{ category.notScoredProjects }})</p>
				</template>
				<template v-if="template === 'base_list' || isOrganizator">
					<!--										@click.prevent="template = 'base_expert'"-->
					<p class="link_back" v-if="isExpert && competition.id.length !== ''"><a
						href="/competition/list_experts_competition">
						<svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M0.558058 5.05806C0.313981 5.30214 0.313981 5.69786 0.558058 5.94194L4.53553 9.91942C4.77961 10.1635 5.17534 10.1635 5.41942 9.91942C5.6635 9.67534 5.6635 9.27961 5.41942 9.03553L1.88388 5.5L5.41942 1.96447C5.6635 1.72039 5.6635 1.32466 5.41942 1.08058C5.17534 0.836505 4.77961 0.836505 4.53553 1.08058L0.558058 5.05806ZM13 4.875H1V6.125H13V4.875Z"
								fill="url(#paint0_linear_1905_3564)"/>
							<defs>
								<linearGradient id="paint0_linear_1905_3564" x1="1" y1="5.5" x2="11.3823" y2="10.1286"
								                gradientUnits="userSpaceOnUse">
									<stop offset="0.0001" stop-color="#F7C100"/>
									<stop offset="1" stop-color="#F69400"/>
								</linearGradient>
							</defs>
						</svg>
						К выбору конкурса</a></p>
					
					
					<h1 class="header_title">Проекты конкурса "{{ competition.name }}"</h1>
					<p class="project_category_text" v-if="current_category">{{ current_category.name }}</p>
					<p class="project_tour_text">{{ getTourName }}</p>
					
					
					<div class="filter_search_form" style="margin: 30px 0 0 0">
						<template v-if="isExpert && competition.id.length !== '' && disable_vote !== '1'">
							<div class="filters_block_wrapper">
								<div class="switchers__wrapper">
									<div class="switch__wrapper">
										<Switch v-model:checked="filterFavorit"></Switch>
										<span @click="filterFavorit = !filterFavorit">Фавориты</span></div>
									<div class="switch__wrapper">
										<Switch v-model:checked="filterNotScored"></Switch>
										<span @click="filterNotScored = !filterNotScored">Неоцененные</span>
									</div>
									<div class="switch__wrapper">
										<Switch v-model:checked="filterHolded"></Switch>
										<span @click="filterHolded = !filterHolded">Отложенные</span>
									</div>
								</div>
								<div class="search_field_wrapper">
									<div class="control">
										<input @input="searchPis" name="search_textfield" class="input search_textfield"
										       type="text"
										       placeholder="Найти проект" v-model="search"/>
									</div>
									<div class="control">
										<input value="Поиск" type="submit" class="button search_button is-info"
										       @click="searchPis">
									</div>
								</div>
							</div>
						</template>
					</div>
					<div style="margin-top: 35px;" class="columns projects_block is-multiline">
						
						<div v-for="(projectInfo,index) in currentItems" :key="index"
						     class="column project_item is-6-desktop"
						     :class="[isEven(index) ? 'project_item_2' : 'project_item_1', is_scored(projectInfo) ? 'is_scored' : 'is_not_scored']">
							<div class="header_project_info">
								<div class="your_score" v-if="is_scored(projectInfo)">Ваша оценка</div>
								<div class="your_score" v-else>Требуется оценка</div>
								
								<div class="right_block" v-if="isExpert">
									
									<div class="hold_on__wrapper">
										<HoldOnIcon
											:is-active="projectInfo.isProjectInfoHolded"
											@add-to-favorite="addToFavorite(projectInfo)"
										></HoldOnIcon>
									</div>
									
									<div class="favorite_button" :data-id="projectInfo.id">
										<div class="favorite__wrapper" v-if="projectInfo.isProjectInfoFavorite">
											<div class="favorite">Фаворит</div>
											<svg @click="favoriteClick(projectInfo.id)" width="22" height="20"
											     viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
												<g filter="url(#filter0_d_1905_3643)">
													<path fill-rule="evenodd" clip-rule="evenodd"
													      d="M20.7986 7.4644L16.1094 11.454L17.4211 17.2804C17.4723 17.5105 17.375 17.7478 17.1726 17.8862C16.9711 18.0238 16.7021 18.0382 16.4851 17.9208L11 14.9529L5.5216 17.9208C5.30469 18.0382 5.03568 18.0238 4.8333 17.8862C4.63176 17.7478 4.53441 17.5105 4.58565 17.2804L5.89737 11.454L1.20142 7.4644C1.02123 7.30591 0.954623 7.06375 1.03148 6.84251C1.10749 6.62127 1.3133 6.46277 1.55752 6.43461L7.84283 5.80467L10.421 0.354804C10.5226 0.139187 10.7498 0 11 0C11.2502 0 11.4774 0.139182 11.579 0.354804L14.1572 5.79664L20.4425 6.42658C20.6867 6.45474 20.8925 6.61323 20.9685 6.83448C21.0454 7.05492 20.9788 7.29789 20.7986 7.45637L20.7986 7.4644Z"
													      fill="white"/>
												</g>
												<defs>
													<filter id="filter0_d_1905_3643" x="0" y="0" width="22" height="20"
													        filterUnits="userSpaceOnUse"
													        color-interpolation-filters="sRGB">
														<feFlood flood-opacity="0" result="BackgroundImageFix"/>
														<feColorMatrix in="SourceAlpha" type="matrix"
														               values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
														               result="hardAlpha"/>
														<feOffset dy="1"/>
														<feGaussianBlur stdDeviation="0.5"/>
														<feComposite in2="hardAlpha" operator="out"/>
														<feColorMatrix type="matrix"
														               values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
														<feBlend mode="normal" in2="BackgroundImageFix"
														         result="effect1_dropShadow_1905_3643"/>
														<feBlend mode="normal" in="SourceGraphic"
														         in2="effect1_dropShadow_1905_3643" result="shape"/>
													</filter>
												</defs>
											</svg>
										</div>
										<svg @click="favoriteClick(projectInfo.id)" v-else width="20" height="18"
										     viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path
												d="M14.7854 11.0732L14.5552 11.269L14.6216 11.5638L15.9331 17.3891C15.9331 17.3892 15.9331 17.3893 15.9331 17.3894C15.9358 17.4017 15.9349 17.4144 15.9294 17.4279C15.9237 17.4418 15.912 17.4586 15.8904 17.4734C15.8435 17.5052 15.7754 17.5094 15.7232 17.4811L15.7231 17.481L10.2379 14.5132L9.99984 14.3843L9.76182 14.5133L4.28351 17.4811C4.23187 17.5091 4.16363 17.5056 4.11532 17.4733C4.07413 17.4445 4.06922 17.4097 4.07363 17.3893C4.07365 17.3893 4.07367 17.3892 4.07369 17.3891L5.38516 11.5638L5.45158 11.2688L5.2211 11.073L0.529666 7.08719C0.513344 7.07221 0.505612 7.05702 0.502312 7.04496C0.498953 7.03269 0.49909 7.02012 0.503795 7.00659L0.504354 7.00496C0.51295 6.97994 0.546219 6.94015 0.61224 6.93163L6.89269 6.30217L7.17393 6.27399L7.29481 6.01848L9.87298 0.568622L9.87329 0.567971C9.88726 0.53833 9.93104 0.5 10 0.5C10.069 0.5 10.1127 0.538338 10.1267 0.567952L10.1271 0.568879L12.7053 6.01071L12.8263 6.26597L13.1073 6.29414L19.3878 6.9236C19.4538 6.93212 19.4871 6.97191 19.4956 6.9969L19.4964 6.99909C19.5008 7.01168 19.5011 7.02407 19.4977 7.03675C19.4941 7.04964 19.4858 7.06562 19.4684 7.08093L19.2993 7.2296L19.2993 7.23267L14.7854 11.0732Z"
												stroke="#1D232D" stroke-opacity="0.5"/>
										</svg>
									</div>
									<div class="score"><span v-if="is_scored(projectInfo)">{{
											projectInfo.projectScore
										}}</span><span v-else>&nbsp;</span></div>
								</div>
							
							</div>
							<div class="columns project_item_block">
								<!--                            <div class="project_score" v-if="isExpert">{{ projectInfo.projectScore }}</div>-->
								<div class="column col1 is-narrow" style="padding-right: 0">
									<a
										:href="'/project/show_expert/'+projectInfo.id+'/'+current+'/'+categoryId">
										<ImageRender
											class-name="project_afisha_image"
											:src="getProjectAvatar(projectInfo.afisha)"
										></ImageRender>
									</a>
								</div>
								<div class="column col2">
									<div>
										<p class="project_category">{{ projectInfo.project_category }}</p>
										<p v-if="isExpert" class="know_more"><a
											:href="'/project/show_expert/'+projectInfo.id+'/'+current+'/'+categoryId"><strong>{{
												projectInfo.project_name
											}}</strong></a></p>
										<p v-if="isOrganizator" class="know_more"><a
											:href="'/project/show_expert/'+projectInfo.id+'/1'"><strong>{{
												projectInfo.project_name
											}}</strong></a></p>
										
										
										<p class="author">{{ projectInfo.project_user_fio }}</p>
										
										<p class="region-percentage" v-if="projectInfo.stage && projectInfo.stage.length">
<!--											<span class="region-label">Регионы:</span>-->
<!--											<span class="region-value">{{ getRegionPercentage(projectInfo) }}%</span>-->
												<span class="region-warning" v-if="isLowRegionPercentage(projectInfo)">
    Процент из регионов меньше 60%
  </span>
										</p>
										<!--                                        <div class="project_logline">{{ projectInfo.project_logline }}</div>-->
									</div>
								</div>
							
							</div>
						</div>
					
					</div>
					<Pagination @change="onPageChange" :page-size="by" v-if="currentItems" v-model:current="current"
					            :total="items.length"></Pagination>
				</template>
			</template>
		</div>
	</div>
</template>

<style scoped>
.cabinet_page .container .content h1.header_title {
	font-weight: 600;
	font-size: 26px;
	color: #1d232d;
}

.header_project_info {
	display: flex;
	background: #e5e9ef;
	height: 50px;
	align-items: center;
	padding-left: 20px;
	padding-right: 10px;
	border-radius: 12px 12px 0 0;
	justify-content: space-between;
}

.region-value-danger {
	color: #ff4d4f !important;
}

.region-warning {
	margin-left: 8px;
	font-size: 12px;
	color: #ff4d4f;
	font-weight: 500;
}

.header_project_info .favorite_button svg {
	cursor: pointer;
}

.header_project_info .favorite_button svg:hover path {
	stroke: #f69400;
}

.is_scored .header_project_info .favorite_button svg:hover path {
	stroke: #fff;
}

.is_scored .header_project_info {
	background: linear-gradient(135deg, #f7c100 0.01%, #f69400 100%);
}

.your_score {
	font-weight: 400;
	font-size: 16px;
	line-height: 120%;
	color: #000;
}

.know_more {
	font-weight: 600;
	font-size: 22px;
	line-height: 120%;
	color: #1d232d;
}

.project_category {
	font-weight: 400;
	font-size: 12px;
	line-height: 118%;
	color: rgba(29, 35, 45, 0.5);
}

.author {
	font-weight: 400;
	font-size: 16px;
	line-height: 120%;
	color: #1d232d;
}

.project_item_block {
	margin-top: 0;
	padding: 20px;
}

.project_item_block {
	border-bottom-left-radius: 12px;
	border-bottom-right-radius: 12px;
}

.project_logline {
	font-weight: 400;
	font-size: 14px;
	line-height: 135%;
	color: rgba(29, 35, 45, 0.8);
	margin-top: 20px;
}

.isActiveStar {
	color: #F69F22;
}

.header_project_info .score {
	border-radius: 12px;
	background: #fff;
	padding: 7px 7px;
	font-weight: 600;
	font-size: 20px;
	line-height: 120%;
	text-align: center;
	color: #1d232d;
	min-width: 40px;
}

.is_not_scored .header_project_info .score {
	background: rgba(255, 255, 255, 0.5);
}

.ant-pagination {
	margin-left: 0;
}

.right_block {
	display: flex;
}

p {
	font-size: 16px;
}

.project_afisha_image {
	border-radius: 12px;
	max-width: 183px;
}


.favorite__wrapper {
	margin-right: 0;
}

.favorite__wrapper {
	display: flex;
	border: 1px solid #fff;
	border-radius: 40px;
	padding: 7px 12px;
	color: #fff;
	align-items: center;
	font-size: 14px;
}

.is_not_scored .favorite__wrapper {
	border: 1px solid #f69400;
	color: #f69400;
}

.is_not_scored .favorite__wrapper svg path {
	fill: #f69400;
	stroke: #f69400;
}

.favorite__wrapper .favorite {
	margin-right: 10px;
}

.favorite_button {
	display: flex;
	align-items: center;
}

.is_scored .favorite_button {
	margin-right: 15px;
}

.is_not_scored .favorite_button {
	margin-right: 15px;
}

.hold_on__wrapper {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 15px;
	cursor: pointer;
}

.is_scored .hold_on__wrapper:deep .not_active path {
	fill: #1D232D;
}

.is_scored .hold_on__wrapper:deep .not_active:hover path {
	fill: #fff;
}

.is_scored .hold_on__wrapper:deep .active path {
	fill: #fff;
}

.is_scored .hold_on__wrapper:deep .active:hover path {
	fill: #1D232D;
}


.ant-switch {
	height: 21px;
	min-width: 38px;
}

.project_tour_text {
	font-weight: 400;
	font-size: 14px;
	color: rgba(0, 0, 0, 0.5);
}

.filters_block_wrapper {
	display: flex;
	justify-content: space-between;
}

.switchers__wrapper {
	display: flex;
	flex-wrap: wrap;
}

.switchers__wrapper .switch__wrapper:not(:last-child) {
	margin-right: 20px;
}

@media (max-width: 1000px) {
	.switchers__wrapper .switch__wrapper {
		margin-bottom: 15px;
	}
}

.switch__wrapper span {
	cursor: pointer;
}

.project_category_text {
	margin-bottom: 10px;
	font-weight: 500;
	font-size: 18px;
	background: linear-gradient(135deg, #f7c100 0.01%, #f69400 100%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
}

@media (max-width: 1000px) {
	.header_title {
		font-size: 21px;
		line-height: normal;
	}
	
	.project_category_text {
		font-size: 16px;
	}
	
	.filters_block_wrapper {
		flex-wrap: wrap;
	}
	
	.search_field_wrapper {
		margin-top: 30px;
	}
	
	.project_category {
		margin-top: 20px;
	}
	
	.project_afisha_image {
		margin: auto;
	}
}
</style>
